<template>
  <div class="preview">
    <div class="preview_mobilePhone" />
    <div class="preview_choice">
      <div class="preview_titleArea">
        <h3 class="title">落地页预览</h3>
        <i class="icon" @click="$emit('close')">x</i>
      </div>
      <div class="preview_selectionArea">
        <h2 class="title">画布尺寸</h2>
        <div class="main">
          <ul class="main_ul">
            <li class="ul_li active">
              <i class="li_icon">
                <svg width="25" height="48" viewBox="0 0 25 48" xmlns="http://www.w3.org/2000/svg"><g fill="#296BEF" fill-rule="evenodd"><text opacity=".3" font-family="inherit" font-size="11" font-weight="500"><tspan x="1" y="28">16:9</tspan></text><path d="M23.5 0A1.5 1.5 0 0 1 25 1.5v45a1.5 1.5 0 0 1-1.5 1.5h-22A1.5 1.5 0 0 1 0 46.5v-45A1.5 1.5 0 0 1 1.5 0h22zm.373 3H1.127A.127.127 0 0 0 1 3.127v42.746c0 .07.057.127.127.127h22.746c.07 0 .127-.057.127-.127V3.127A.127.127 0 0 0 23.873 3zM13.75 1h-2.5a.25.25 0 1 0 0 .5h2.5a.25.25 0 1 0 0-.5z" fill-rule="nonzero" /></g></svg>
              </i>
              <span class="li_text">主流机型</span>
            </li>
            <li class="ul_li">
              <i class="li_icon">
                <svg width="24" height="48" viewBox="0 0 25 50" xmlns="http://www.w3.org/2000/svg"><g fill="#282C44" fill-rule="evenodd"><text opacity=".3" font-family="inherit" font-size="11" font-weight="500"><tspan x="1" y="28">18:9</tspan></text><path d="M24 0a1 1 0 0 1 1 1v48a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h23zm-.127 2H1.127A.127.127 0 0 0 1 2.127v45.746c0 .07.057.127.127.127h22.746c.07 0 .127-.057.127-.127V2.127A.127.127 0 0 0 23.873 2z" fill-rule="nonzero" /></g></svg>
              </i>
              <span class="li_text">全面型</span>
            </li>
            <li class="ul_li">
              <i class="li_icon">
                <svg width="23" height="48" viewBox="0 0 24 50" xmlns="http://www.w3.org/2000/svg"><g fill="#282C44" fill-rule="evenodd"><path d="M22.204 0C23.196 0 24 .804 24 1.796v46.408c0 .992-.804 1.796-1.796 1.796H1.796A1.796 1.796 0 0 1 0 48.204V1.796C0 .804.804 0 1.796 0h20.408zm-2.848 1c-.1 0-.18.08-.18.18v.32a.5.5 0 0 1-.5.5H5.094a.5.5 0 0 1-.5-.5v-.32c0-.1-.08-.18-.18-.18H2.198C1.536 1 1 1.536 1 2.198v45.604C1 48.464 1.536 49 2.198 49h19.604c.662 0 1.198-.536 1.198-1.198V2.198C23 1.536 22.464 1 21.802 1h-2.446z" fill-rule="nonzero" /><text opacity=".3" font-family="inherit" font-size="8" font-weight="500"><tspan x="1" y="28">19.5:9</tspan></text></g></svg>
              </i>
              <span class="li_text">刘海型</span>
            </li>
            <li class="ul_li">
              <i class="li_icon">
                <svg width="26" height="48" viewBox="0 0 25 46" xmlns="http://www.w3.org/2000/svg"><g fill="#282C44" fill-rule="evenodd"><text opacity=".3" font-family="inherit" font-size="11" font-weight="500"><tspan x="4" y="25">3:2</tspan></text><path d="M24 0a1 1 0 0 1 1 1v44a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h23zM12.532 39.384c-1.189 0-2.152.959-2.152 2.142 0 1.183.963 2.142 2.152 2.142 1.188 0 2.152-.959 2.152-2.142a2.147 2.147 0 0 0-2.152-2.142zM23.873 5H1.127A.127.127 0 0 0 1 5.127v31.746c0 .07.057.127.127.127h22.746c.07 0 .127-.057.127-.127V5.127A.127.127 0 0 0 23.873 5zM15.75 2h-3.5a.25.25 0 1 0 0 .5h3.5a.25.25 0 1 0 0-.5zm-5 0a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5z" fill-rule="nonzero" /></g></svg>
              </i>
              <span class="li_text">小瓶手机</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="preview_qRCodeArea">
        <h3 class="title">手机预览</h3>
        <div class="qRCodeArea_main">
          <div v-loading="loading" class="imgBox">
            <img class="img" :src="dat.qrCode">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { previewLandingPage } from '@/api/landingPage.js'
export default {
  props: {
    activeItem: {}
  },
  data() {
    return {
      loading: false,
      dat: {}
    }
  },

  async created() {
    this.loading = true
    const data = await previewLandingPage({
      account_id: this.activeItem.account_id,
      page_id: this.activeItem.page_id
    })
    this.loading = false
    this.dat = data.data
    console.log(this.dat)
  }
}
</script>

<style scoped lang="less">
.preview{
  border-radius: 5px;
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .preview_mobilePhone{
       width: 422px;
       padding: 0 50px;
       background: #f5f6f8;
       height: 760px;
  }

  .preview_choice{
      width: 450px;
      height: 760px;
      background-color: #fff;

      .preview_titleArea{
        padding: 20px;
        display: flex;
        justify-content: space-between;
        .title{
           font-weight: bold;
        }
        .icon{
          font-style: normal;
          cursor: pointer;
          font-size: 18px;
          &:hover{
            font-weight: bold;
          }
        }
      }

      .preview_selectionArea{
        .title{
         margin: 20px 0 10px;
         font-size: 14px;
         font-weight: bold;
         padding: 0px 22px;
        }
        .main{
          .main_ul{
            display: flex;
            justify-content: space-around;
            .ul_li{
              display: flex;
              flex-direction: column;
              width: 90px;
              height: 100px;
              box-shadow: 0px 0px 0px 1px #ccc;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              &.active{
                box-shadow: 0px 0px 0px 2px #296bef;
              }
              .li_icon{

              }
              .li_text{

              }
            }
          }
        }
      }

      .preview_qRCodeArea{
        .title{
         margin: 20px 0 10px;
         font-size: 14px;
         font-weight: bold;
         padding: 0px 22px;
        }

        .qRCodeArea_main{
          padding: 20px;
          .imgBox{
            padding: 15px;
            border: 1px solid #d6d9e0;
            border-radius: 4px;
            width: 167px;
            height: 167px;
            .img{
            width: 135px;
            cursor: pointer;
            }
          }
        }
      }
  }
}
</style>
